function TelPlugin() {

	let $ = jQuery,
		thisObject = this;
	this.reCreate = function() {

		$( '[data-tel-plugin]' ).each( function() {
			let callTrack,
				lastQueryString,
				formattedPhone,
				arr,
				qs,
				phoneText,
				link = this,
				$link = $( link ),
				pattern = /[a-zA-Z%]/g;
			if ( ! $link.data( 'telPluginRunning' ) ) {

				{
					// This is old code. Not Understand what is it do?
					// Try
					// https://stage.anytimefitness.com/training/fitness-consultation/?club=4309&it_is_last_query_param=9988776655
					// I think it code must be work on some pages, but not understand where is.

					// Getting the Query String from current Url
					qs = window.location.search;
					if ( '' !== qs ) {
						phoneText = link.innerHTML;

						// remove ? from ?club=afNumber
						qs = qs.replace( '?', '' );

						// separate GET-values
						arr = qs.split( '&' );
						lastQueryString = arr[arr.length - 1].split( '=' );
						callTrack = !['chid','schedule_id'].includes(lastQueryString[0]) ? lastQueryString[1] : false; //prevent unintended swaps


						if (!pattern.test(callTrack)) { // don't even bother if query string contains letters or url encoded characters
							callTrack = callTrack.replace(/\D+/g, ''); // strip anything that isn't a digit -- in case there is already formatting applied
							if ( 10 == callTrack.length ) { // check length for 10 chars
								if (0 < phoneText.indexOf('-')) {
									formattedPhone = callTrack.substr(0, 3) + '-' + callTrack.substr(3, 3) + '-' + callTrack.substr(6, 4);
								} else if (0 < phoneText.indexOf('.')) {
									formattedPhone = callTrack.substr(0, 3) + '-' + callTrack.substr(3, 3) + '-' + callTrack.substr(6, 4);
								} else {
									formattedPhone = '(' + callTrack.substr(0, 3) + ')' + ' ' + callTrack.substr(3, 3) + ' ' + callTrack.substr(6, 4);
								}
								link.innerHTML = formattedPhone;

								// replace anchor href tel link, if one exists
								if (0 == link.href.indexOf('tel:')) {
									link.href = 'tel:' + formattedPhone;
								}
							}
						}
					}
				}
				$link.data( 'telPluginRunning', true );
			}
		} );

	};

	// on ready
	$( function() {
		thisObject.reCreate();

		// on update page
		$( 'body' ).on( 'click', '[data-tel-plugin]', function( event ) {
			let $link = $( this );
		} );

		// on update page
		$( 'body' ).on( 'update_dom', function() {
			thisObject.reCreate();
			console.log('update_dom');
		} );

	} );

}

